import { render, staticRenderFns } from "./CustomerLinks.vue?vue&type=template&id=09f9caa0&scoped=true"
import script from "./CustomerLinks.vue?vue&type=script&lang=js"
export * from "./CustomerLinks.vue?vue&type=script&lang=js"
import style0 from "./CustomerLinks.vue?vue&type=style&index=0&id=09f9caa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f9caa0",
  null
  
)

export default component.exports